// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"288aad84","707":"3424a9dc","729":"b43f9b1c"}[chunkId] + ".js";
};